export enum ReportRepeatedDays {
  DAILY = '1111111',
  WEEKDAY = '0111110'
}
